var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-footer"},[_vm._v(" Copyright By brandesign.org.cn 2023 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }